var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-5xl mx-auto mt-5"},[(_vm.config)?_c('OnlineStore2Support',{staticClass:"mb-20"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }